<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
.selectCss select {
    width: 48% !important;
}
</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose">

        <List v-if="editFormData.content">

            <ListItem>订单号：{{editFormData.order_sn}}</ListItem>
            <ListItem>提单类型：{{editFormData.type==1?'广告':(editFormData.type==2?'产品与服务':'增值服务')}}</ListItem>
            <ListItem>提单资源：{{editFormData.source_name}}</ListItem>
            <ListItem>行业：{{editFormData.content.trade}}</ListItem>
            <ListItem v-if="editFormData.type==1">广告主：{{editFormData.content.name}}</ListItem>
            <ListItem v-if="editFormData.type==2">小程序/公众号名称：{{editFormData.content.name}}</ListItem>
            <ListItem v-if="editFormData.type==1">落地页：<a :href="editFormData.content.weburl" target="_blank">点击预览</a></ListItem>
            <ListItem v-if="editFormData.type==1">投放资质：
                <a v-for="(item, index) in editFormData.content.clientele.split(',')" :key="index" :href="url+item" target="_blank">
                <img :src="url+item" style="width: 50px;height: 50px;"/>
                </a>
            </ListItem>
            <ListItem v-if="editFormData.type==1">账显金额：{{editFormData.content.account_total}}</ListItem>
            <ListItem v-if="editFormData.type==1">支付金额：{{editFormData.content.true_total}}</ListItem>
            <ListItem v-if="editFormData.type==2">是否认证：{{editFormData.content.is_auth==1?'已认证':'未认证'}}</ListItem>
            <ListItem v-if="editFormData.type!=1">数量：{{editFormData.content.num}}</ListItem>
            <ListItem>提单备注：{{editFormData.content.agent_mark}}</ListItem>


            <ListItem>
                <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
                    <FormItem label="审核状态:" prop="status">
                    <RadioGroup v-model="formData.status">
                        <Radio label="1">
                            <span>待审核</span>
                        </Radio>
                        <Radio label="2">
                            <span>已通过</span>
                        </Radio>
                        <Radio label="3">
                            <span>已驳回</span>
                        </Radio>
                    </RadioGroup>
                    </FormItem>
                    <FormItem label="审核备注:" prop="mark">
                        <Input type="textarea" v-model="formData.mark" placeholder=""></Input>
                    </FormItem>
                    <FormItem>
                        <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
                    </FormItem>
                </Form>
            </ListItem>

        </List>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            editFormData:Object
        },
        name: "Modeldetail",
        data() {
            return {
                url:this.config.sourceUrl,
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    id: '',
                    status: '1',
                    mark:''
                },
                ruleCustom: {//验证
                    status: [
                        {required: true, message: '审核状态必须选择', trigger: 'change' },
                    ],
                    mark: [
                        {required: true, message: '审核备注必须填写', trigger: 'blur' },
                    ],
                },
            }
        },
        components: {
        },
        watch:{
            showModel(val){
                if(val){
                    // this.getData()
                }
            }
        },
        created(){
        },
        methods: {
            openOrClose(value) {
                console.log(this.editFormData)
                if(value === true) {

                    this.formData.id = this.editFormData.id
                    this.formData.status = this.editFormData.status.toString();
                    this.formData.mark = this.editFormData.mark;
                    this.title = '提单详情'
                } else { //关闭弹框后要做的处理

                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        this.axios.post(this.config.urlArray.reviewOrder, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });

                    }
                })
            },

            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                this.formData.id = ''
            }
        }
    }
</script>
